import "../styles/index.css"
import "@hotwired/turbo"
import { application } from "./controllers/application.js"
import WordmarkController from "./controllers/wordmark_controller.js"
import HeaderController from "./controllers/header_controller.js"

application.register("wordmark", WordmarkController)
application.register("header", HeaderController)
